import {
  TIMESTAMP_ALL,
  TIMESTAMP_GET,
  TIMESTAMP_DEL,
  TIMESTAMP_PUT,
  TIMESTAMP_POST,
  TIMESTAMP_LOADING,
  TIMESTAMP_ERROR,
  TIMESTAMP_RESET,
  TIMESTAMP_PENDING_APPROVAL_COUNT,
} from '../../actions/types';

const initialState = {
  timestamp: null,
  isLoading: true,
  isCompleted: true,
  pendingApprovalCount: 0,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case TIMESTAMP_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
        pendingApprovalCount: state.pendingApprovalCount,
      };
    case TIMESTAMP_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
        pendingApprovalCount: state.pendingApprovalCount,
      };
    case TIMESTAMP_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case TIMESTAMP_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case TIMESTAMP_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case TIMESTAMP_RESET:
      return { timestamp: null, isLoading: true, isCompleted: true, pendingApprovalCount: state.pendingApprovalCount };
    case TIMESTAMP_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case TIMESTAMP_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case 'TIMESTAMP_UPDATE_LOCAL':
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
        pendingApprovalCount: state.pendingApprovalCount,
      };
    case TIMESTAMP_PENDING_APPROVAL_COUNT:
      return { ...state, pendingApprovalCount: action.payload };
    default:
      return state;
  }
}
